import { EventEmitter, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GTM_EVENTS } from '../constants/widget-constants';
import { CustomFieldsDao } from '../db-models/appointment-custom-fields-dao';
import { UserDao } from '../db-models/user-data-dao';
import { CartItem, EventCartItem, GuestModel } from '../models/cart.model';
import { GoogleAnalyticsService } from './google-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class CustomEventService {

  private googleAnalyticsService = inject(GoogleAnalyticsService);

  currentPage: string;
  previousPage: string;
  finalSuccessMessageChangedEvent = new EventEmitter<string>();
  customerChangedInInternalWidgetEvent = new EventEmitter<{ customerUuid: string }>();
  disableCalendarNextButtonEvent = new EventEmitter<boolean>();
  resetPayPalOrderDetailEvent = new EventEmitter<any>();
  couponChangeEvent = new EventEmitter<any>();
  addonsPriceChangeEvent = new EventEmitter<number>();
  cartItemsChangeEvent = new EventEmitter<{
    cart?: CartItem[],
    eventCart?: EventCartItem[],
    type: string,
  }>();
  additionalGuestChangeEvent = new EventEmitter<{
    discount: number,
    finalPrice: number,
    additionalGuests: GuestModel[]
  }>();
  // The last event total the cart overview announced. The payment view is created after that
  // announcement, so it starts from this value instead of the net price it is handed.
  lastAdditionalGuestChange: { discount: number, finalPrice: number, additionalGuests: GuestModel[] } | null = null;
  paypalOrderSuccessfullEvent = new EventEmitter<any>();
  hideBookingButtonEvent = new EventEmitter<{ hide: boolean }>();
  paymentGatewayErrorEvent = new EventEmitter<any>();
  childCustomFieldsLoadedEvent = new EventEmitter<CustomFieldsDao[]>();
  removeChildCustomFieldsEvent = new EventEmitter<number[]>();
  checkEndOfProcessEvent = new EventEmitter<any>();
  emailChangedEvent = new EventEmitter<any>();

  // services are loaded
  servicesLoadedEvent = new EventEmitter<void>();

  // to track next/previous month click on calendar
  eventCalendarIsNextPressed: boolean = undefined;
  eventCalendarIsPreviousPressed: boolean = undefined;

  // to handle iframe parent window navigation actions
  iFrameNavigationFromParent = new EventEmitter<string>();

  // Refresh calendar manually from different component
  refreshCalendarEvent = new EventEmitter<void>();

  // Identify troubleshooting mode is enable or not
  toggleTroubleshootEvent = new BehaviorSubject(false);

  gtmStartTriggered = false;

  // Update widget date context based on selected qualificatino question
  updateWidgetDateContext = new EventEmitter<{
    date: string;
    date_context_start: number;
    date_context_end: number;
  }>();

  // When store has default worker but seleceted service isn't supported by worker then
  // Have to redefined default worker otherwise always wrong worker will be picked (Fixing issue for EGK)
  redefineDefaultWorkerIdEvent = new EventEmitter<UserDao[]>();

  triggerGroupApoointmentStartEvent(): void {
    if (this.gtmStartTriggered === false) {
      this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.EVENT_BOOKING_START);
      this.gtmStartTriggered = true;
    }
  }

  // Remove dependent custom fields when customer is changed or removed from the form
  removeDependentCustomFieldsEvent = new EventEmitter<void>();
}
